// Models
import { ExceptionDetail } from '../ExceptionDetail/ExceptionDetail';

export class Result<T> {
  isSuccess: boolean;
  errorMessage: string;
  exceptionDetail: ExceptionDetail;
  data: T;
  validationErrors: any;
}
